import React from 'react';
import './howItWorks.css';

const steps = [
  {
    id: "01",
    title: "Connect & Initialize",
    description: "Plug in your existing data sources and define your mission parameters in our secure environment."
  },
  {
    id: "02",
    title: "Neural Optimization",
    description: "Our core engine analyzes your specific industry patterns to train dedicated, high-precision agents."
  },
  {
    id: "03",
    title: "Global Deployment",
    description: "Launch your agents into the field with sub-100ms latency across our distributed global edge network."
  }
];

const HowItWorks = () => {
  return (
    <section className="how-it-works" id="faq">
      <div className="how-header">
        <span className="how-badge">Process</span>
        <h2 className="how-title">How It Works</h2>
        <p className="how-subtitle">
          From initialization to global scale in three intuitive steps.
        </p>
      </div>

      <div className="steps-container">
        {/* Neural Path Line */}
        <div className="steps-path"></div>
        
        {steps.map((step, index) => (
          <div key={index} className="step-item">
            <div className="step-number-container">
              <span className="step-number">{step.id}</span>
              <div className="step-dot"></div>
            </div>
            <div className="step-content">
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
